<template>
  <d-form>
    <d-form-row class="form-group mb-2">
      <d-col cols="12" md="6">
        <div class="d-flex w-100 bg-black justify-content-between">
          <label>Texto Original</label>
          <div>
            <d-checkbox
              toggle
              class="custom-toggle-sm mb-0"
              style="margin-right: 12px"
              v-model="model.keepPunctuation"
            >
              Manter Pontuação
            </d-checkbox>
            <d-checkbox
              toggle
              class="custom-toggle-sm mb-0"
              style="margin-right: 12px"
              v-model="model.keepLineBreaks"
            >
              Manter Quebras de Linha
            </d-checkbox>
          </div>
        </div>
        <textarea
          v-model="model.text"
          class="form-control mt-1"
          rows="10"
          placeholder="Cole seu texto aqui..."
        />
      </d-col>

      <d-col cols="12" md="6">
        <div class="mb-4">
          <copy-text-title :onCopyText="copyText" title="Texto Limpo" />
        </div>
        <textarea
          v-model="model.result"
          class="form-control"
          rows="10"
          readonly
        />
      </d-col>
    </d-form-row>

    <d-form-row class="form-group">
      <d-col cols="12" class="pt-1">
        <action-buttons :onGenerate="generateResult" :onClear="cleanText" />
      </d-col>
    </d-form-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';

import CopyTextTitle from '_shared/CopyTextTitle.vue';
import ActionButtons from '_shared/ActionButtons.vue';

export default {
  name: 'special-character-remover-form',
  components: {
    ActionButtons,
    CopyTextTitle,
  },
  data() {
    return {
      model: {
        text: '',
        result: '',
        keepPunctuation: true,
        keepLineBreaks: true,
      },
    };
  },
  methods: {
    ...mapActions(['activeAlert']),
    cleanText() {
      this.model.text = '';
      this.model.result = '';
    },
    sanitizeText(text) {
      if (!text) return '';

      let normalizedText = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

      if (!this.model.keepLineBreaks) {
        normalizedText = normalizedText.replace(/\n/g, ' ');
      }

      const allowedChars = this.model.keepPunctuation ? /[^a-z0-9\s.,!?;:-]/g : /[^a-z0-9\s\n]/g;
      normalizedText = normalizedText.replace(allowedChars, ' ');

      const spaceRegex = this.model.keepLineBreaks ? /[ \t]+/g : /\s+/g;
      return normalizedText.replace(spaceRegex, ' ').trim();
    },
    generateResult() {
      if (!this.model.text.trim()) {
        this.model.result = '';
        return;
      }

      this.model.result = this.sanitizeText(this.model.text);
    },
    copyText() {
      if (!this.model.result) return;

      navigator.clipboard.writeText(this.model.result).then(() => {
        this.activeAlert({ message: 'Texto copiado!', theme: 'success' });
      }).catch(err => {
        console.error('Erro ao copiar:', err);
      });
    },
  },
};
</script>
